'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const button_types = require('../Button/button.types.js');
const button = require('../Button/button.js');
const spot = require('../Spot/spot.js');
const spotTag_style = require('./spotTag.style.js');

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["dataAttr"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var defaultHandlers = {};
var defaultFollowButtonProps = {};
var SpotTag = function SpotTag(_ref) {
  var alt = _ref.alt,
    active = _ref.active,
    activeBorderColor = _ref.activeBorderColor,
    _ref$followButtonProp = _ref.followButtonProps,
    followButtonProps = _ref$followButtonProp === void 0 ? defaultFollowButtonProps : _ref$followButtonProp,
    className = _ref.className,
    _ref$dark = _ref.dark,
    dark = _ref$dark === void 0 ? false : _ref$dark,
    _ref$handlers = _ref.handlers,
    handlers = _ref$handlers === void 0 ? defaultHandlers : _ref$handlers,
    id = _ref.id,
    isFavorite = _ref.isFavorite,
    lazyload = _ref.lazyload,
    link = _ref.link,
    name = _ref.name,
    rel = _ref.rel,
    target = _ref.target,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'spot-tag' : _ref$testId,
    type = _ref.type,
    _ref$isSpotTile = _ref.isSpotTile,
    isSpotTile = _ref$isSpotTile === void 0 ? false : _ref$isSpotTile,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '36' : _ref$width,
    showFollow = _ref.showFollow,
    spotSource = _ref.spotSource,
    superName = _ref.superName,
    isFollowed = _ref.isFollowed,
    followHandlers = _ref.followHandlers,
    followLabel = _ref.followLabel;
  // Call the handler when the event is triggered
  var invokeHandler = function invokeHandler(t, e) {
    handlers[t](e);
  };
  var componentAttr = {};
  if (isSpotTile) {
    componentAttr = {
      active: active,
      as: spotTag_style.SpotTile,
      activeBorderColor: activeBorderColor,
      className: className,
      'data-testid': "".concat(testId, "__spot-button"),
      'aria-pressed': active
    };
    Object.keys(handlers).forEach(function (key) {
      componentAttr[key] = function (e) {
        invokeHandler(key, e);
      };
    });
  } else {
    if (link) {
      componentAttr = {
        as: spotTag_style.SpotLink,
        dataAttr: {
          'data-testid': "".concat(testId, "__link")
        },
        handlers: handlers,
        rel: rel,
        target: target,
        url: link,
        className: className
      };
    } else {
      componentAttr = {
        className: className,
        'data-testid': "".concat(testId, "__spot-no-link")
      };
    }
  }
  var _ref2 = followButtonProps || {},
    _ref2$dataAttr = _ref2.dataAttr,
    dataAttr = _ref2$dataAttr === void 0 ? {} : _ref2$dataAttr,
    restFollowButtonProp = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React__default.createElement(spotTag_style.SpotTagContainer, null, /*#__PURE__*/React__default.createElement(spotTag_style.SpotWrapper, componentAttr, /*#__PURE__*/React__default.createElement(spot, {
    alt: alt,
    id: id,
    isFavorite: isFavorite,
    lazyload: lazyload,
    spotSource: spotSource,
    type: type,
    width: width
  }), /*#__PURE__*/React__default.createElement(spotTag_style.SpotTagCopy, {
    isSpotTile: isSpotTile,
    isMultiline: !!superName
  }, superName && /*#__PURE__*/React__default.createElement(spotTag_style.SuperTagName, {
    "data-testid": "".concat(testId, "__super-name"),
    dark: dark,
    isSpotTile: isSpotTile
  }, superName), name && /*#__PURE__*/React__default.createElement(spotTag_style.TagName, {
    "data-testid": "".concat(testId, "__name"),
    dark: dark,
    fontsizeOverride: superName && 17,
    isSpotTile: isSpotTile
  }, name))), showFollow && /*#__PURE__*/React__default.createElement(button, _extends({
    active: isFollowed,
    dataAttr: _objectSpread({
      'data-testid': "".concat(testId, "__follow")
    }, dataAttr),
    handlers: followHandlers,
    size: button_types.ButtonSizes.XSMALL,
    shape: button_types.ButtonShapes.PILL_SOLID,
    styleName: button_types.ButtonStyles.GREY,
    theme: {
      dark: dark
    }
  }, restFollowButtonProp), followLabel || 'Follow'));
};

module.exports = SpotTag;
